import React from 'react';

const usePageNav = (params, onUpdate) => {
    const currentPage = React.useMemo(() => {
        return parseInt(params.page) || 0;
    }, [params.page]);
    const setCurrentPage = React.useCallback(
        newPage => {
            if (currentPage === newPage) {
                return;
            }
            return onUpdate(newPage);
        },
        [currentPage, onUpdate]
    );
    return [currentPage, setCurrentPage];
};

export default usePageNav;
